<template>
    <button class="btn btn-primary" @click.stop="addStamp"><span class="material-symbols-outlined">add</span> {{ $trans.get("__JSON__.Add manual time tracking stamp") }}</button><br><br>
    <table class="table table-striped">
        <thead>
            <tr>
                <th>
                    {{ $trans.get("__JSON__.Date") }}
                </th>
                <th>
                    {{ $trans.get("__JSON__.Duration") }}
                </th>
                <th>
                    {{ $trans.get("__JSON__.Comment") }}
                </th>
                <th>
                    {{ $trans.get("__JSON__.Project") }}
                </th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(stamp, key) in list">
                <td>
                    {{ stamp.intimeFormatted }}
                </td>
                <td>
                    <span v-if="stamp.outtime">{{ stamp.durationFormatted }}</span>
                    <span v-if="!stamp.outtime"><strong>{{ $trans.get("__JSON__.Ongoing stamp") }}</strong></span>
                </td>
                <td>
                    {{ stamp.comment_from_manual }}
                </td>
                <td>
                    {{ stamp.project?.name }}
                </td>
                <td>
                    <span class="material-symbols-outlined" v-if="stamp.outtime" @click.stop="editStamp(key)">edit</span>
                </td>
            </tr>
        </tbody>
    </table>
    <Teleport to="body">
        <div class="modal" tabindex="-1" id="manualtimetrackingmodal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content" v-if="manualTimeTrackingStamp">
                    <div class="modal-header">
                        <h4>{{ $trans.get("__JSON__.Edit manual time tracking stamp from") }} {{ manualTimeTrackingStamp.intimeFormatted }}</h4>
                    </div>
                    <div class="modal-body">
                        <div v-if="errors" class="alert alert-danger" role="alert">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="durationFormatted">{{ $trans.get("__JSON__.Duration") }}</label>
                                <input type="text" class="form-control" v-model="manualTimeTrackingStamp.durationFormatted" id="durationFormatted" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="projectId">{{ $trans.get("__JSON__.Project") }}</label>
                                <select class="form-control" v-model="manualTimeTrackingStamp.project_id" id="projectId">
                                    <option v-for="project in projects" v-bind:value="project.id">
                                        {{ project.project_type?.name }} - {{ project.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="comment">{{ $trans.get("__JSON__.Comment") }}</label>
                                <textarea class="form-control" v-model="manualTimeTrackingStamp.comment_from_manual" id="comment">
                                </textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ $trans.get("__JSON__.Close") }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="saveStamp">
                            {{ $trans.get("__JSON__.Save") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
    <Teleport to="body">
        <div class="modal" tabindex="-1" id="manualtimetrackingmodalAdd">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>{{ $trans.get("__JSON__.Add manual time tracking stamp") }}</h4>
                    </div>
                    <div class="modal-body">
                        <div v-if="errors" class="alert alert-danger" role="alert">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="date">{{ $trans.get("__JSON__.Date") }}</label>
                                <input type="text" class="form-control" v-model="newStamp.date" id="date" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="durationFormatted">{{ $trans.get("__JSON__.Duration") }}</label>
                                <input type="text" class="form-control" v-model="newStamp.durationFormatted" id="durationFormatted" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="projectId">{{ $trans.get("__JSON__.Project") }}</label>
                                <select class="form-control" v-model="newStamp.project_id" id="projectId">
                                    <option value="0">{{ $trans.get("__JSON__.Please Select") }}</option>
                                    <option v-for="project in projects">
                                        {{ project.project_type?.name }} - {{ project.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="comment">{{ $trans.get("__JSON__.Comment") }}</label>
                                <textarea class="form-control" v-model="newStamp.comment_from_manual" id="comment">
                                </textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ $trans.get("__JSON__.Close") }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="saveNewStamp">
                            {{ $trans.get("__JSON__.Save") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "ManualTimeTracking",
    props: {
        stamps: Array,
        projects: Array,
    },
    data() {
        return {
            manualTimeTrackingStamp: null,
            newStamp: {
                date: '',
                durationFormatted: '',
                comment_from_manual: '',
                intimeFormatted: '',
                project_id: 0,
            },
            list: [],
            errors: null,
        }
    },
    created() {
        this.list = this.stamps;
    },
    methods: {
        editStamp(key) {
            this.errors = null;
            this.manualTimeTrackingStamp = this.stamps[key];
            $("#manualtimetrackingmodal").modal("show");
        },
        saveStamp() {
            if (this.manualTimeTrackingStamp) {
                axios
                    .post("/api/manualtimetracking/save/" + this.manualTimeTrackingStamp.id, this.manualTimeTrackingStamp)
                    .then((resp) => {
                        $("#manualtimetrackingmodal").modal("hide");
                    })
                    .catch((error) => {
                        console.log(error);
                        this.errors = error.response.data.errors;
                    });
            }
        },
        addStamp() {
            this.newStamp = {
                date: '',
                durationFormatted: '',
                comment_from_manual: '',
                project_id: 0,
            };
            this.errors = null;
            $("#manualtimetrackingmodalAdd").modal("show");
        },
        saveNewStamp() {
            axios
                .post("/api/manualtimetracking/new/", this.newStamp)
                .then((resp) => {
                    $("#manualtimetrackingmodalAdd").modal("hide");
                    this.newStamp.intimeFormatted = this.newStamp.date;
                    this.newStamp.outtime = true;
                    this.list.push(this.newStamp);
                })
                .catch((error) => {
                    console.log(error);
                    this.errors = error.response.data.errors;
                });
        }
    }
}
</script>

<style lang="scss"></style>
